import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as utils from '@owl-nest/utils'

import * as url from '@boutique/url'
import * as entities from '@boutique/entities'

type Tag = { kind?: string; name: string; slug: string }
type TagListProps = {
  className?: string
  tagList: Tag[]
}

function TagListComponent({ className, tagList }: TagListProps): React.ReactElement {
  return (
    <TagContainer className={className}>
      {tagList.map((tag) => {
        return (
          <Link href={getTagHref(tag)} key={tag.slug} prefetch={false} scroll>
            <TagWrapper>
              <plume.styles.copy.S>{tag.name}</plume.styles.copy.S>
            </TagWrapper>
          </Link>
        )
      })}
    </TagContainer>
  )
}

function getTagHref(tag: Tag): string {
  const filter = tag.kind === undefined ? undefined : KIND_MAPPING[tag.kind]

  if (!filter)
    return url.products({
      query: { searchableTag: utils.text.slugify(tag.name, ' ') },
    }).path

  return url.products({
    query: {
      facetFilters: {
        [filter]: (entities.search.product.ARRAY_FILTERS as readonly string[]).includes(filter) ? [tag.slug] : tag.slug,
      },
    },
  }).path
}

const KIND_MAPPING: Record<string, keyof entities.search.product.Filters> = {
  types: 'types',
  environmentalPillar: 'environmentalPillars',
  socialPillar: 'socialPillars',
}

const TagWrapper = styled.div`
  border: 1px solid ${plume.COLORS.GREY_SHADE_5};
  border-radius: 40px;
  display: inline-flex;
  align-items: center;
  margin: 5px;
  padding: 0 10px;

  ${plume.styles.copy.S} {
    position: relative;
    top: -1px;
  }
`

const TagContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 340px;
  margin: 0px auto 80px;

  ${plume.styles.copy.S} {
    color: ${plume.COLORS.GREY_SHADE_2};
    margin: 0 4px;
    padding: 2px 0;
  }
`

export const TagList = styled(TagListComponent)``
